/*global jQuery */
(function ($) {
  "use strict";

  /*
  ===============================
  --------- JS Index ------------

  01. Background Image JS
  02. Off Canvas JS
  03. Responsive Slicknav JS
  04. Counter To Up JS
  05. Sticky Header JS
  06. Scroll To Top JS
  07. Skills Bar JS

  00. All Slick Slider Active

  ==================================
  */

  jQuery(document).ready(function ($) {
    /*--------------------------
        01. Background Image JS
    ---------------------------*/
    var bgSelector = $("[data-bg]");
    bgSelector.each(function (index, elem) {
      var element = $(elem),
        bgSource = element.data('bg');
      element.css('background-image', 'url(' + bgSource + ')');
    });


    /*------------------------
        02. Off Canvas JS
    --------------------------*/
    var canvasWrapper = $(".off-canvas-cog");
    $(".btn-cog").on('click', function () {
      canvasWrapper.addClass('active');
      $("body").addClass('fix');
    });

    $(".off-canvas-overlay, .btn-close").on('click', function () {
      $(".off-canvas-wrapper").removeClass('active');
      $("body").removeClass('fix');
    });


    /*------------------------------
        03. Responsive Slicknav JS
    --------------------------------*/
    $('.main-menu').slicknav({
      appendTo: '.res-mobile-menu',
      allowParentLinks: true,
      closeOnClick: true,
      removeClasses: false,
      closedSymbol: '<i class="mdi mdi-plus"></i>',
      openedSymbol: '<i class="mdi mdi-minus"></i>',
    });

    var resCanvasWrapper = $(".off-canvas-menu");
    $(".btn-menu").on('click', function () {
      resCanvasWrapper.addClass('active');
      $("body").addClass('fix');
    });

    /*------------------------
      06. Scroll To Top JS
     -------------------------*/
    $(".btn-scroll-top").on('click', function () {
      $('html, body').animate({
        scrollTop: 0
      }, 1500);
    });

    /*--------------------------
      10. Magnific Popup JS
     ---------------------------*/
    $('.btn-play').magnificPopup({
      type: 'iframe'
    });

  });



  const headerOffset = 50;
  const Header = $('#header-area');

  let lastScrollTop = 0;

  $(window).scroll(function() {
    const st = $(this).scrollTop();

    $('#header-area').attr('data-scrollTop', st);

    if (st < lastScrollTop) {
      Header.removeClass('is--hidden');
    }
    else if ($(document).scrollTop() > headerOffset) { //&& !header.hasClass('is--menu-open')
      Header.addClass('is--hidden');
    }

    if ($(document).scrollTop() > headerOffset + 200) {
      Header.addClass('is--filled');
    } else {
      Header.removeClass('is--filled');
    }

    lastScrollTop = st;

  });

  $(window).trigger('scroll');

}(jQuery));